import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import orderBy from "lodash/orderBy";
import moment from "moment";

const styles = theme => ({
  card: {
    width: 340,

    boxShadow: "none",
    margin: "0px 5px"
  },
  media: {
    height: 220,
    objectFit: "cover",
    borderRadius: 5
  },

  cardContentArea: {
    padding: "4px 0px",
    "&:last-child": {
      paddingBottom: 0
    },
    marginBottom: 20
  },
  year: {
    backgroundColor: "#A61D55",
    borderRadius: "3.2px",
    color: "white",
    padding: "0 4px"
  },
  yearArea: {
    textTransform: "uppercase",
    color: "#A61D55",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "16px",
    paddingTop: 4
  },
  launchicon: {
    fontSize: 12
  },
  articleLink: {
    textDecoration: "none",
    color: "#A61D55"
  },
  CarouselDiv: {
    height: 190,
    objectFit: "cover",
    borderRadius: 5
  }
});

class ListingCard extends React.Component {
  render() {
    const {
      listing,
      handleListingEnter,
      handleListingLeave,
      openInNewWindow,
      mapShowing
    } = this.props;

    const getNextOpenHouse = listing => {
      const nextOpenHouse = orderBy(listing.openHouses, ["date", "asc"])[0];
      return (
        moment(nextOpenHouse.date).format("ddd") +
        " " +
        nextOpenHouse.openHouseTimeFrame
      );
    };
    const width = mapShowing ? "50%" : "25%";
    return (
      <div id={listing.mlsNumber} className="cardone" style={{ width: width }}>
        <div className="card img-loaded">
          <a
            className="card-link"
            href={`/listings/detail/${listing.mlsNumber}`}
            rel="noopener noreferrer"
            target={openInNewWindow ? "_blank" : ""}
            onMouseEnter={e => handleListingEnter(listing)}
            onMouseLeave={e => handleListingLeave()}
          >
            <div className="card-photo">
              <img className="lazy" alt="" src={listing.primaryPhotoUrl} />
            </div>
            <div className="info">
              <div className="price">
                <span className="price-title">
                  <NumberFormat
                    value={listing.price}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </span>
              </div>
              <div
                className=""
                className={!listing.totalBedRooms ? "hide" : "top-base-info"}
              >
                <span>{listing.totalBedRooms} Beds</span>
                <span>{listing.totalBathsStr} Baths</span>
              </div>
              <div className="flex-info">
                <div className="flex-info-left">
                  <div className="addresslink desc-comma">
                    <span>{listing.addressStreet} </span>
                    <span className="address-city">{listing.addressCity}</span>
                    <span> {listing.addressState}</span>
                    <span className="nocomma"> {listing.addressZip}</span>
                  </div>
                  <div className="mlsinfo" />
                </div>
              </div>
            </div>
            {listing.isHobson && (
              <span className="hobson-card-badge">
                <img
                  src="/HobsonTheme.OrchardCore/img/hobson_hires_150.png"
                  alt="hobsonlogo_thumbnail"
                  width="100px"
                />
              </span>
            )}
          </a>
          <div className="labels">
            {listing.ribbonText && listing.RibbonText !== "" && (
              <span className="label bg-info">{listing.ribbonText}</span>
            )}
            {(listing.status === 'CNTG' || listing.status === 'PEND') && (
              <span className="label bg-warning">
                {listing.status}
              </span>
            )}
            {listing.isHobson && (
                <span className="label bg-hobson">
                    Will CO-OP
                </span>
            )}
            
            
          </div>

          {listing.openHouses && listing.openHouses.length > 0 && (
            <div className="labels openhouse-overlay" style={{ right: "5px", left: "unset", width: "unset" }}>
              <span className="label bg-secondary">
                  {getNextOpenHouse(listing)}
              </span>
            </div>
          )}
        </div>
      </div>
      /* </CardContent> */
      /* </Card> */
    );
  }
}

ListingCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ListingCard);
